import { api } from '@api'
import type { EventForm } from './eventSchema'
import type { OverrideForm } from '../Override/eventSchema'

// Fetches unique groups specifically from the events table
export const fetchEventGroups = async (search: string) => {
	let query = api()
		.from('events')
		.select('group')
		.not('group', 'is', null)
		.order('group', { ascending: true })

	if (search.trim()) {
		query = query.ilike('group', `%${search}%`)
	}

	const { data, error } = await query

	if (error) {
		console.error('Error fetching event groups:', error)
		throw new Error(error.message)
	}

	// Deduplicate and map to { label, value }
	const uniqueGroups = Array.from(new Set((data || []).map((e) => e.group)))

	return uniqueGroups.map((group) => ({
		label: group as string,
		value: group as string,
	}))
}

export const saveEvent = async (values: EventForm) => {
	const { data, error } = await api().from('events').insert(values).select().single()

	if (error) throw new Error(error.message)
	return data
}

export const updateEvent = async ({
	id,
	values,
}: { id: string; values: EventForm | OverrideForm }) => {
	const { data, error } = await api()
		.from('events')
		.update(values)
		.eq('id', id)
		.select()
		.single()

	if (error) throw new Error(error.message)
	return data
}
